import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className='eduzz-ui-layout-topbar-header' style={{ padding: '0.75rem 2rem' }}>
      <Link to='/'>
        <img className='h-full max-w-full' alt='MyEduzz' src='https://cdn.eduzzcdn.com/topbar/myeduzz.svg' />
      </Link>
    </header>
  );
};

export default Header;
